<template>
  <v-alert
    border="left"
    icon="mdi-check"
    color="#ffe7e6"
    elevation="2"
    style="font-size: 90%"
  >
    <v-row>
      <v-col cols="12">
        <b>「すこやか女性の健康」コース</b><br/>
        女性の健康支援セミナー（動画配信）開催<a class="ml-4" target="_blank" href="./manual/women_health_support.pdf">詳細はこちら</a><br/>
        ※コース参加者以外も視聴できます。
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: 'ResultTopicWomenHealth',
  computed: {
    isMobile () { // モバイル判定
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
/* v-btn 上書き */
.mobile-margin-top {
  margin-top: 2rem;
}
</style>
